import React from 'react'
import styled from 'styled-components'
import ScrollAnimation from 'react-animate-on-scroll'

import { white } from 'styles/colors'
import { media } from 'styles/media'
import { H3, H4, fontWeights, lineHeights } from 'styles/typography'
import * as spacing from 'styles/spacing'

import Section, { SectionBlock } from 'components/Section'
import Wrapper from 'components/Wrapper'

const Container = styled.div`
  position: static;
  text-align: center;
  color: ${white};
  padding-bottom: 2rem;

  ${media.xLarge`
    padding-bottom: 3rem;
  `};
`

const List = styled.div`
  display: grid;
  grid-gap: ${spacing.large};
  margin-top: ${spacing.small};
  counter-reset: steps;

  ${media.small`
    grid-gap: ${spacing.xLarge};
  `};

  ${media.medium`
    grid-template-columns: repeat(3, 1fr);
    margin-top: ${spacing.medium};
  `};
`

const Heading = styled(H3)`
  color: ${white};
  margin-bottom: 0.5em;
  text-transform: uppercase;
`

const Step = styled.div`
  position: static;
  max-width: 280px;
  margin-left: auto;
  margin-right: auto;
  counter-increment: steps;
`

const Label = styled(H4)`
  color: ${white};
  font-weight: ${fontWeights.regular};
  line-height: ${lineHeights.base};

  &:before {
    display: block;
    content: 'Step ' counter(steps);
    font-weight: ${fontWeights.bold};
    margin-bottom: 0.25em;
  }
`

const Figure = styled.img`
  height: 78px;
  margin-bottom: ${spacing.small};

  ${media.medium`
    height: 86px;
    margin-bottom: ${spacing.medium};
  `};

  ${media.large`
    margin-bottom: ${spacing.medium};
  `};
`

const Steps = () => (
  <Container id="steps">
    <Section>
      <Wrapper>
        <SectionBlock>
          <Heading as={ScrollAnimation} animateIn="fadeInUp" offset={0} animateOnce>
            Subscribing is super easy
          </Heading>
        </SectionBlock>
        <SectionBlock>
          <List>
            <Step as={ScrollAnimation} animateIn="fadeInUp" offset={0} delay={200} animateOnce>
              <Figure src={`${process.env.BASE_PATH}/images/subscribe/icons/pods.png`} />
              <Label>Add pods and quantity of your choosing to cart</Label>
            </Step>
            <Step as={ScrollAnimation} animateIn="fadeInUp" offset={0} delay={400} animateOnce>
              <Figure src={`${process.env.BASE_PATH}/images/subscribe/icons/calendar.png`} />
              <Label>Select the date for your monthly delivery</Label>
            </Step>
            <Step as={ScrollAnimation} animateIn="fadeInUp" offset={0} delay={600} animateOnce>
              <Figure src={`${process.env.BASE_PATH}/images/subscribe/icons/clipboard.png`} />
              <Label>Place your order and enjoy the savings</Label>
            </Step>
          </List>
        </SectionBlock>
      </Wrapper>
    </Section>
  </Container>
)

export default Steps
